<template>
  <Modal v-model="modal" :title="$t('title.w30')" :mask-closable="false">
    <div>
      <Form label-position="top" :model="form" ref="form" :rules="formRule">
        <FormItem :label="$t('label.w50')" prop="realName">
          <Input :placeholder="$t('pl.p25')" v-model="form.realName"/>
        </FormItem>
      </Form>
    </div>
    <template slot="footer">
      <Button type="primary" :disabled="form.realName==''" @click="submit">{{$t('btn.b45')}}</Button>
    </template>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      form: {
        realName: ""
      },
      formRule: {
        realName: [
          { required: true, message: this.$t('msg.m42'), trigger: "submit" }
        ]
      },
      modal: false
    };
  },
  methods: {
    async submit() {
      // 提交前验证表单
      let valid = await this.$refs.form.validate();
      if (!valid) return;
      let res = await this.$axios.post("/Member/RZJProfile/AddInvestmentScreeMan", this.form);
      if (res.err) return res.throw();
      this.$emit('done');
      this.$Message.success( this.$t('msg.m43'));
      this.modal = false;
    }
  },
  watch: {
    modal(v) {
      if(!v) this.$refs.form.resetFields();
    }
  }
};
</script>
